import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import Notifications from '~/components/Notifications';

import logo from '~/assets/logo-noBg.svg';

import { Container, Content, Profile, AdminPanel } from './styles';

export default function Header() {
  const profile = useSelector(state => state.user.profile);

  return (
    <Container>
      <Content>
        <Link to="/dashboard">
          <img src={logo} alt="OrthoQuiz" />
        </Link>

        <aside>
          <AdminPanel isadmin={profile.admin ? 'true' : null} to="/panel">
            Admin Panel
          </AdminPanel>

          <Notifications />

          <Profile>
            <div>
              <strong>{profile.name}</strong>
              <Link to="/profile">Meu Perfil</Link>
            </div>
            <Link to="/profile">
              <img
                src={
                  (profile.avatar && profile.avatar.url) ||
                  `https://api.adorable.io/avatars/50/${profile.name}@adorable.png`
                }
                alt={profile.name}
              />
            </Link>
          </Profile>
        </aside>
      </Content>
    </Container>
  );
}
